module.exports = __webpack_public_path__ + "img/return-code-doc.bd946f29.svg";